import { useLocation, useSearchParams } from 'react-router-dom';

import { WIZARD_PARAM, isCarveOutPath } from './constants';
import { WizardGate } from './WizardGate';

/**
 * The wizard overlay host: mounted once next to `OnboardingRedirect`, inside the router and
 * outside the route table, so a wizard link works on every client route without any route naming
 * it. A wizard stores no page of its own, so the path is consulted for exactly two things —
 * refusing to mount on the signup wizard's own screens, and knowing whether a signed-out visitor
 * is already on a route that will send them to sign in.
 *
 * This is the client half of one contract: the same `myFeatureWizard` lookup, the same
 * `recordFeatureWizardEvent` mutation and the same shared step component town-square renders,
 * with nothing app-specific behind any of them.
 *
 * Everything else is deliberately mounted BELOW this component rather than gated inside it, so a
 * page with no wizard parameter costs nothing at all — not even the flag lookup.
 */
export function FeatureWizardHost() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const slug = searchParams.get(WIZARD_PARAM);
  if (!slug) return null;
  if (isCarveOutPath(pathname)) return null;

  // Keyed by slug: a second link in the same session is a fresh landing, never leftover state.
  return <WizardGate key={slug} slug={slug} />;
}
